import { useRef, useState } from "react";
import { SystemCore } from "../../../../Core/System/SystemCore";
import { SystemDataLoadingStatus, SystemPageType } from "../../../../Model/SystemModels";
import { Loader } from "../../../Common/Loader/Loader";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { AdminBookingCalendarCard } from "../AdminBookingCalendarCard/AdminBookingCalendarCard";

export const AdminBookingCalendarList : React.FC = () => {
    const [dataStatus, setDataStatus] = useState(SystemDataLoadingStatus.Loaded);
    const [loaderMessage, setLoaderMessage] = useState("");
    const cardRef = useRef<PageContainerBase>(null);
    
    if (!SystemCore.isFinishedDataStatus(dataStatus))
        return <Loader text={loaderMessage}></Loader>;
    else
        return (
            <>
                <PageContainer endpoint={'/odata/booking/calendar'} pageType={SystemPageType.List} title={"Booking calendars"} cardRef={cardRef} backAllowed showAllowed insertAllowed updateAllowed deleteAllowed>
                    <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>
                    <PageDefinitionContainer type={ContainerType.PageStructure}>
                        <ListHeaderEntry name="Legal entity" fieldName="legalEntityCode" minWidth={150} maxWidth={250} />
                        <ListHeaderEntry name="Distributor" fieldName="distributorCode" minWidth={150} maxWidth={250} />
                        <ListHeaderEntry name="Partner business contract" fieldName="partnerBusinessContractCode" minWidth={150} maxWidth={250} />
                        <ListHeaderEntry name="Language" fieldName="languageCode" minWidth={150} maxWidth={250} />
                        <ListHeaderEntry name="Calendar Id" fieldName="calendarId" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry name="Sync active" fieldName="syncActive" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry name="Last syncronization date" fieldName="lastSyncronizationDate" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry name="Syncronization delay days" fieldName="syncronizationDelayDays" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry name="Default for appointments" fieldName="defaultForAppointments" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry name="Lead syncronization" fieldName="leadSyncronization" minWidth={100} maxWidth={200} />
                    </PageDefinitionContainer>
                </PageContainer>
                <AdminBookingCalendarCard ref={cardRef} />
            </>
        );
}